import {
  Group,
  Stack,
  Text,
  ThemeIcon,
} from '@mantine/core'
import {
  Check,
  X,
} from 'lucide-react'

import { PASSWORD_REQUIREMENTS } from '@common/utils/validation/constants'
import { validatePasswordStructure } from '@common/utils/validation/authValidators'

interface PasswordRulesMessageProps {
  password: string
}

export const getAuthPasswordValidationError = (password: string) => {
  if (!password) {
    return 'Password is required'
  }

  return validatePasswordStructure(password) ? null : 'Password does not meet the requirements'
}

export const getConfirmPasswordError = (
  password: string,
  confirmation: string,
) => {
  if (!confirmation) {
    return 'Confirm password is required'
  }

  return password === confirmation ? null : "Passwords don't match"
}

export const PasswordRulesMessage = ({
  password,
}: PasswordRulesMessageProps) => (
  <Stack gap={4}>
    <Text
      size={'sm'}
      fw={600}
    >
      Password should include:
    </Text>
    <Stack gap={2}>
      {PASSWORD_REQUIREMENTS.map((requirement) => {
        const isMet = requirement.test(password)
        const Icon = isMet ? Check : X

        return (
          <Group
            key={requirement.id}
            gap={'xs'}
            wrap={'nowrap'}
          >
            <ThemeIcon
              aria-label={`${requirement.label} ${isMet ? 'met' : 'not met'}`}
              color={isMet ? 'teal' : 'gray'}
              radius={'xl'}
              size={16}
              variant={isMet ? 'filled' : 'outline'}
            >
              <Icon size={12} />
            </ThemeIcon>
            <Text
              c={isMet ? 'teal.7' : 'gray.6'}
              size={'sm'}
            >
              {requirement.label}
            </Text>
          </Group>
        )
      })}
    </Stack>
  </Stack>
)
